module.exports = __webpack_public_path__ + "img/finger.19708e93.svg";